import { render, staticRenderFns } from "./TasksScheduleList.vue?vue&type=template&id=583c0956&scoped=true"
import script from "./TasksScheduleList.vue?vue&type=script&lang=js"
export * from "./TasksScheduleList.vue?vue&type=script&lang=js"
import style0 from "./TasksScheduleList.vue?vue&type=style&index=0&id=583c0956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c0956",
  null
  
)

export default component.exports